export default function PHP_bin2hex() {
  return (
    <div>
      <h1>PHP_bin2hex</h1>
    </div>
  );
}
